import { parseHelpSpaPath } from "@/app/(public)/help/_components/help-spa-path";

export interface MessengerSource {
  readonly title: string;
  readonly pageId: string;
}

const LINK_ONLY_LINE = /^\s*(?:[-*•]\s+)?\[([^\]]+)\]\(([^)\s]+)\)\s*$/;

/** Help page id of a link to this org's help center, else null. */
export function helpPageIdOf(href: string, orgSlug: string): string | null {
  let path = href;
  if (/^https?:\/\//.test(href)) {
    try {
      path = new URL(href).pathname;
    } catch {
      return null;
    }
  }
  const target = parseHelpSpaPath(path, orgSlug);
  return target?.kind === "page" ? target.pageId : null;
}

/** Trailing help-link-only lines become source chips; links inside sentences stay in the body. */
export function splitSourceLinks(
  text: string,
  orgSlug: string,
): { readonly body: string; readonly sources: readonly MessengerSource[] } {
  const lines = text.replace(/\s+$/, "").split("\n");
  const sources: MessengerSource[] = [];
  while (lines.length > 0) {
    const last = lines[lines.length - 1] ?? "";
    if (last.trim().length === 0 && sources.length > 0) {
      lines.pop();
      continue;
    }
    const match = LINK_ONLY_LINE.exec(last);
    const pageId = match?.[2] === undefined ? null : helpPageIdOf(match[2], orgSlug);
    if (match?.[1] === undefined || pageId === null) break;
    sources.unshift({ title: match[1], pageId });
    lines.pop();
  }
  const seen = new Set<string>();
  const unique = sources.filter((s) => {
    if (seen.has(s.pageId)) return false;
    seen.add(s.pageId);
    return true;
  });
  return { body: lines.join("\n").trim(), sources: unique };
}
